
import { ArtistItem, GallerySystemArtist } from '@/dataTypes/types';
import { useGalleryStore } from '@/store/GalleriesStore';
import { usePrivateSellersStore } from '@/store/PrivateSellersStore';
import { useAuthStore } from '@/store/AuthStore';
import { defineComponent, PropType } from 'vue';
import { debounce } from 'lodash';

export default defineComponent({
  props: {
    show: Boolean,
    galleryArtists: [] as PropType<ArtistItem[]>,
  },
  data() {
    const galleryStore = useGalleryStore();
    const privateSeller = usePrivateSellersStore();
    const auth = useAuthStore();
    return {
      galleryStore,
      privateSeller,
      auth,
      search: '',
      allArtists: [] as GallerySystemArtist[],
      searchTimeout: 0,
    };
  },
  async created() {
    this.allArtists = await this.getArtists({
      limit: 100,
      offset: 0,
      keyword: this.search,
    });
  },
  computed: {
    isPrivateSeller() {
      return this.auth.userRole === 'private_seller';
    },
  },
  methods: {
    async getArtists(params: {
      limit: number;
      offset: number;
      keyword: string;
    }) {
      if (this.isPrivateSeller) {
        return await this.privateSeller.getAllArtists(params);
      } else {
        return await this.galleryStore.getAllArtists(params);
      }
    },
    isArtistInGallery(artist: GallerySystemArtist): boolean {
      if (!this.allArtists || !this.galleryArtists) {
        return false;
      }
      const currentArtists = this.isPrivateSeller
        ? this.privateSeller.myArtists
        : this.galleryArtists;
      const artistNames = this.allArtists.map((artist) => artist.full_name);
      return (
        artistNames.includes(artist.full_name) &&
        currentArtists.some(
          (artistItem) => artistItem.full_name === artist.full_name
        )
      );
    },
    async searchArtists(keyword: string) {
      this.allArtists = await this.getArtists({
        limit: 100,
        offset: 0,
        keyword,
      });
    },
    updateSearch(event: Event) {
      this.search = (event.target as HTMLInputElement)?.value;
      this.debouncedSearchArtists();
    },
    // if you have a better way to achieve this please apply it.
    debouncedSearchArtists: debounce(function (this: any) {
      if (this.search) {
        this.searchArtists(this.search);
      }
    }, 1000),
    async addArtist(id: number) {
      this.$emit('add-artist', id);
    },
  },
});
